'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { PrudsysProductsRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/PrudsysProductsRecommendationsFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';
import { useHashParameters } from '@packages/modules/src/hooks/useHashParameters/useHashParameters';
import { PrudsysProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysProductsRecoSlider/PrudsysProductsRecoSlider.client';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useIntl } from 'react-intl';

/* GraphQL */ `
  fragment PrudsysProductsRecommendations on Product {
    defaultCategory
    orderNumber
    brand {
      name
    }
  }
`;

export type PrudsysProductsRecommendationsProps = {
  data: FragmentType<typeof PrudsysProductsRecommendationsFragmentDoc>;
};

/**
 * The `PrudsysProductsRecommendations` component is used as a wrapper for the `PrudsysProductsRecoSlider` component.
 * It displays the recommendations for the prudsysProducts Query.
 * */
export const PrudsysProductsRecommendations = ({ data }: PrudsysProductsRecommendationsProps) => {
  const { orderNumber, brand, defaultCategory } =
    unmask<typeof PrudsysProductsRecommendationsFragmentDoc>(data);

  const { category = '' } = useHashParameters();
  const { formatMessage } = useIntl();
  const {
    product: { hasTransparentSection },
  } = useConfig();

  return (
    <PrudsysProductsRecoSlider
      brand={brand?.name ?? ''}
      categoryIds={[defaultCategory ?? category]}
      productId={orderNumber}
      pageTemplate="detailview"
      fetchOnThreshold
      elementIndex={0}
      title={formatMessage({
        defaultMessage: 'Andere Kunden interessierte auch',
        id: 'rde.prudsys.headline-fallback',
      })}
      key={`${orderNumber}0`}
      {...(hasTransparentSection && {
        backgroundColor: 'transparent',
      })}
    />
  );
};
